import React from 'react';
import { cn } from '@/lib/utils';

interface FactRowProps {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
  className?: string;
}

export function FactRow({ label, value, mono = false, className }: FactRowProps) {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div className={cn('flex items-start gap-2 text-xs', className)}>
      <span className="text-muted-foreground shrink-0 min-w-[100px]">{label}</span>
      <span className={cn('font-medium text-foreground break-all', mono && 'font-mono text-[10px]')}>
        {value}
      </span>
    </div>
  );
}
